// React Dependencies
import React, { useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Icon, MenuItem, MenuList } from '@material-ui/core';
import { toast } from 'react-toastify';
import { Switch, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Internal Dependencies
import PrivateRouteAdmin from '../../routing/PrivateRoute';
import AlbumInfo from './info';
import AlbumPhotos from './photos';
import apiService from '../../../services.js/apiService';
import Colours from '../../../styles/colours';
import { Url } from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import { editPage } from '../../../actions/admin/pageAction';

const AlbumRouter = ({ match, pageInView, dispatchEditPage }) => {
  const { pageId, id: albumId } = match.params;

  const getPageData = async () => {
    try {
      if (!IsEmpty(pageId)) {
        const p = await apiService.getPageById(pageId);
        dispatchEditPage(p);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getPageData();
  }, [pageId]);

  return (
    <div className="w-100">
      <div className="d-flex justify-content-start content-header">
        <h1 className="d-flex align-items-center">
          <Link
            title="Back"
            to={`${Url.Albums.replace(':pageId', pageId)}`}
            className="d-flex align-items-center"
          >
            <Icon className="back">arrow_back</Icon>
          </Link>
          {`${!IsEmpty(pageInView) ? pageInView.name : ''} / album / ${albumId}`}
        </h1>
      </div>
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-md-2" style={{ backgroundColor: Colours.White }}>
            <MenuList>
              <Link to={`${match.url}`}>
                <MenuItem>Info</MenuItem>
              </Link>
              <Link to={`${match.url}/photos`}>
                <MenuItem>Photos</MenuItem>
              </Link>
            </MenuList>
          </div>
          <div className="col-md-10 card-left">
            <Switch>
              <PrivateRouteAdmin exact path={`${match.path}`} component={AlbumInfo} />
              <PrivateRouteAdmin exact path={`${match.path}/photos`} component={AlbumPhotos} />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

AlbumRouter.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape(Object).isRequired,
    url:    PropTypes.string.isRequired,
    path:   PropTypes.string.isRequired,
  }).isRequired,

  pageInView: PropTypes.shape({
    id:   PropTypes.number,
    name: PropTypes.string,
  }),

  dispatchEditPage: PropTypes.func.isRequired,
};

AlbumRouter.defaultProps = {
  pageInView: { id: null, name: null },
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchEditPage: (p) => dispatch(editPage(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlbumRouter);
